import { render, staticRenderFns } from "./PreCadastro.vue?vue&type=template&id=0b3aae3c&scoped=true"
import script from "./PreCadastro.script.js?vue&type=script&lang=js&external"
export * from "./PreCadastro.script.js?vue&type=script&lang=js&external"
import style0 from "./PreCadastro.css?vue&type=style&index=0&id=0b3aae3c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3aae3c",
  null
  
)

export default component.exports